import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import createEndpoints from "./endpoints/index.js";
import providers from "./provider/index.js";
import axios from "axios";
import * as encrypts from "./encrypt.js";
export default class Mixin {
  constructor() {
    this.session = null;
    this.endpoints = void 0;
    this.provider = void 0;
    this.provider = new providers.HttpProvider();
    this.endpoints = createEndpoints(this.provider);
  }

  config(session) {
    this.session = session;
    this.provider.instance.interceptors.request.use(config => {
      var _config$method, _config$data;

      if (!this.session) return config;
      const url = axios.getUri(config);
      const token = encrypts.signAuthenticationToken(this.session.client_id, this.session.session_id, this.session.private_key, (_config$method = config.method) !== null && _config$method !== void 0 ? _config$method : "", url, (_config$data = config.data) !== null && _config$data !== void 0 ? _config$data : "");
      config.headers = _objectSpread(_objectSpread({}, config.headers), {}, {
        Authorization: `Bearer ${token}`
      });
      return config;
    });
  }

}
export { encrypts, providers, createEndpoints };